<app-closeable-dialog-title
  [allowMaximize]="false"
  title="Bug fixing">
</app-closeable-dialog-title>

<form [formGroup]="issueForm" (ngSubmit)="onSubmit()">
  <div mat-dialog-content>
    <p>Current version: {{version}}</p>
    <p>Stage: {{stage}}</p>
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" placeholder="What is the problem..."/>
      @if(issueForm.get('title')?.hasError('required')) {
        <mat-error>Title is required.</mat-error>
      }
      @if(issueForm.get('title')?.hasError('minlength')) {
        <mat-error>Minimum 5 characters required.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Description</mat-label>
      <textarea matInput rows="5" formControlName="body" placeholder="What is the problem description..."></textarea>
      @if(issueForm.get('body')?.hasError('required')){
        <mat-error>Description is required.</mat-error>
      }
      @if(issueForm.get('body')?.hasError('minlength')){
        <mat-error>Minimum 10 characters required.</mat-error>
      }
    </mat-form-field>

    @if (lastErrors && lastErrors.length) {
      <h3>Last 3 errors:</h3>
      <mat-list>
        @for (error of lastErrors; track $index) {
          <mat-list-item>{{ error }}</mat-list-item>
        }
      </mat-list>
    }
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button class="save-btn" type="submit" [disabled]="issueForm.invalid">
      <mat-icon>save</mat-icon>
      Submit
    </button>
  </div>
</form>
